import { useState, type KeyboardEvent } from 'react';
import { X } from 'lucide-react';

export function TagInput({
  values,
  onChange,
  placeholder = 'Digite e pressione Enter…',
}: {
  values: string[];
  onChange: (v: string[]) => void;
  placeholder?: string;
}) {
  const [draft, setDraft] = useState('');

  function add() {
    const v = draft.trim();
    if (v && !values.includes(v)) onChange([...values, v]);
    setDraft('');
  }

  function onKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      e.preventDefault();
      add();
    } else if (e.key === 'Backspace' && !draft && values.length) {
      onChange(values.slice(0, -1));
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-xl border border-line bg-white p-2 focus-within:border-brand-orange focus-within:ring-2 focus-within:ring-brand-orange/20">
      {values.map((v) => (
        <span key={v} className="inline-flex items-center gap-1 rounded-lg bg-cloud px-2 py-1 text-xs font-medium text-ink">
          {v}
          <button onClick={() => onChange(values.filter((x) => x !== v))} className="text-slate hover:text-danger" aria-label={`Remover ${v}`}>
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        onBlur={add}
        placeholder={values.length ? '' : placeholder}
        className="min-w-[120px] flex-1 bg-transparent px-1 py-1 text-sm text-ink placeholder:text-slate/60 focus:outline-none"
      />
    </div>
  );
}
